import { API_URL } from '../config/config';
import UnauthorizedError from '../errors/UnauthorizedError';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/return-await */

export default class BaseApiService {
  private apiUrl = API_URL;

  private async errorHandler(url: string, res: any, json = true) {
    if (!res.ok) {
      if (res.status === 401) {
        throw new UnauthorizedError('Unauthorized request');
      }

      throw new Error(`Could not fetch ${url}, received ${res.status}`);
    }

    if (json) {
      return await res.json();
    }

    return res;
  }

  async getResource(url: string, ac?: AbortController) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      // credentials: 'include',
      signal: ac ? ac.signal : null,
      headers: {
        Authorization: this.getAuthToken(),
        Key: window.sessionStorage.getItem('key') ?? '',
      },
    });
    return this.errorHandler(url, res);
  }

  async postResource(url: string, data: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  async postResourceFullResponse(url: string, data: any, ac?: AbortController) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: JSON.stringify(data),
      signal: ac ? ac.signal : null,
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res, false);
  }

  async postResourceBlob(url: string, data: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: data,
      headers: {
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  async postResourceFormData(url: string, data: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'POST',
      body: data,
      headers: {
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  async putResource(url: string, data: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  async patchResource(url: string, data: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  async deleteResource(url: any) {
    const res = await fetch(`${this.apiUrl}${url}`, {
      method: 'DELETE',
      headers: {
        Authorization: this.getAuthToken(),
      },
    });
    return this.errorHandler(url, res);
  }

  getAuthToken() {
    // if (window.sessionStorage.getItem('viewAsClient')) {
    //   return '';
    // }
    return `Bearer ${window.sessionStorage.getItem('token')}`;
  }
}
